import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Photos from '../../../../commonModules/interface/input-files.jsx';
import PopUp from '../../../../commonModules/interface/PopUp.jsx';

import PreviewFacture from './PreviewFacture.jsx';
import { Button, Box, FormControlLabel, Switch } from '@material-ui/core';
import InputText, { TextArea } from '../../../../commonModules/interface/form-input-inline.jsx';
import { toast } from 'react-toastify';


class FormShop extends Component {

    componentDidUpdate(prevProps) {
        // Update photos state when shop props change (e.g., after logo upload)
        if (prevProps.shop?.logo !== this.props.shop?.logo) {
            const newPhotos = (this.props.shop?.logo?.filename) 
                ? [this.props.shop.logo] 
                : [];
            
            this.setState({
                photos: newPhotos,
                shop: {
                    ...this.state.shop,
                    logo: this.props.shop.logo
                }
            });
        }
    }
    
    state = { 
        shop: this.props.shop || {
            // address: "40 rue Laffitte",
            // bottom_info: "Reserve de Propriété: ... Pas de retour de marchandise ni échange sauf cas de défaut de fabrication",
            // bottom_info2: "Audit & Conseil - Fourniture - Installation - Maintenance",
            // bottom_info3: "Ecobank n° 11085828...",
            // city: "Paris",
            // country: "FRANCE",
            // email: "Contact@myjoulebox.com",
            // latitude: "48.874154",
            // longitude: "2.338170",
            // name: "MyJouleBox",
            // oldLogo: "",
            // photo: [],
            // tel: "0987654321",
            // tel2: "123456789",
            id:"",
            name: "",
            city: "",
            address: "",
            country: "",
            tel: "",
            tel2: "",
            email: "",
            latitude: "",
            longitude: "",
            bottom_info:"",
            bottom_info2:"",
            bottom_info3:"",
            shop_disabled: false,
            photo: [],
            oldLogo:""
        },
        errors:{
            name: "",
            city: "",
            address: "",
            tel: "",
            email: "",
            country: "",
            latitude: "",
            longitude: "",
            bottom_info:"",
        },
        floats:[
            'latitude',
            'longitude'
        ],
        preview: false,
        updatePhotos: false,
        // Initialize photos with existing logo if it exists
        photos: (this.props.shop && this.props.shop.logo && this.props.shop.logo.filename) 
            ? [this.props.shop.logo] 
            : [],
     }


    handleChange = (e) => { 
        const { name, value } = e.target
        // console.log("HANDLE CHANGE", { name, value})
        const regex = /^-?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        // const regex = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        if(this.state.floats.includes(name)){
            if(value === "" || regex.test(value)){
                this.setState({
                    ...this.state,
                    shop : {
                        ...this.state.shop,
                        [name] : value
                    }
                })
            }
        } else {
            this.setState({
                ...this.state,
                shop : {
                    ...this.state.shop,
                    [name] : value
                }
            })
        }
    }

    setPhotos = (list) => {
        console.log("[INFO] SETPHOTOS", list);
        
        this.setState({
            ...this.state,
            shop:{
                ...this.state.shop,
                photo:list
            }
        })
    }
    createRef(){
        const { SHOPS } = this.props
        let country = this.state.shop.country
        country = country.normalize('NFD').replace(/[\u0300-\u036f]/g, "") // remove accents
        
        // ref = type_country_id ex: SHOP_BEN_1R77YB8
        let ref = "SHOP_" + (country).substr(0,3) + "_" + (Math.random().toString(36)).substr(2,7)
        ref = ref.toUpperCase()
        console.log("[INFO] createRef " ,ref)
        
        if(!isEmpty(SHOPS)){
            Object.values(SHOPS).map( shop => {// checks if ref of product is used already
                if(shop.ref === ref){ // if exist
                    ref = this.createRef() // create new one
                }
            })
        }
        return ref
    }

    validate = () => {
        let noErrors = true
        let errors = {}
        let newShop = Object.assign({}, this.state.shop)

        Object.values(this.props.SHOPS).map( shop => {
            if(
                shop.name === newShop.name &&
                shop.city === newShop.city &&
                shop.address === newShop.address &&
                shop.country === newShop.country &&
                shop.id !== newShop.id
            ) {
                noErrors = false
                toast.warning(  "Ce magasin existe déjà")
                return
            }
        })
        if(newShop.ref){ // form already submitted
            noErrors = false
            return noErrors
        }

        Object.keys(this.state.errors).map( field => {
            if( isEmpty(newShop[field]) && !newShop[field] ){ // input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
            } else {
                errors[field] = ""   
            }
        })

        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors,
            preview: noErrors,
        })

        // return noErrors
    }
    uploadLogo = async(photo)=>{
        try {
            console.log("[INFO] SHOPS submit upload photos ", photo, photo.file);

            const resPhotos = await fetch('/stocks/uploadPhotos', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({file : photo}),
                credentials: 'same-origin',
            }); 

            const bodyRes = await resPhotos.json()
            console.log("[INFO] SHOPS submit upload photos res", bodyRes)
            if (bodyRes.path) {
                return {filename:bodyRes.path}
            } 
            else {
                console.log("[ERROR] while uploading shop logo ");
                return {filename:""}
            }
            
        } catch (error) {
            console.log("[ERROR] SUBMIT PHOTO UPLOAD", error);
            return {filename:""}
        }
    }

    handleSubmit = async () => {
        // if(this.validate()){
            const logo = await this.uploadLogo(this.state.shop.photo[0])
            let newShop = Object.assign({}, this.state.shop)
            newShop.shop_ref = this.createRef()
            newShop.logo = logo

            newShop.latitude = this.state.shop.latitude ? parseFloat(this.state.shop.latitude) : null
            newShop.longitude = this.state.shop.longitude ? parseFloat(this.state.shop.longitude) : null
            console.log({newShop});
                
            await this.props.createShop(newShop)
                
            if(this.props.STATE.shops.error){
                console.log("ERROR", this.props.STATE.shops.error);

                toast.error( this.props.STATE.shops.error)
            } else{
                console.log("fetched");

                toast.success("Le magasin a été créé avec succès")
                this.props.handleClose()
            }            

    }

    handleSubmitUpdate = async () => {
        // if( this.validate()){
            let newShop = Object.assign({}, this.props.shop, this.state.shop)
            const { floats } = this.state
            delete newShop.src

            floats.map( field => {
                newShop[field] = parseFloat(newShop[field])
                // console.log("type :", typeof newShop[field], "field: ", field );
            })

            try{
                await this.props.updateShop(newShop)

                if(this.props.STATE.shops.error){                    
                    toast.error( this.props.STATE.shops.error.message)
                } else {

                    toast.success( "Le magasin a été modifié avec succès")
                    this.props.handleClose()
                }
                
            } catch(err){
                console.log("[ERROR] SUBMIT UPDATE ", err);
                toast.error("Un Problème est survenu")
            }

    }
    handleSubmitPhotos = async () => {
        let data = {
            photos: this.state.photos,
            shop: this.props.shop.id
        }
        
        try {
            if (this.state.photos[0].filetype !=="image/jpeg" ){
                toast.error("Image must be a JPG ou JPEG file")
                return
            }
            if (this.state.photos.length > 1 ){
                toast.error("Only 1 image could be sent")
                return
            }

        }catch (error) {
            toast.error("[ERROR]"+error.message)
            return
        }

        try{
            await this.props.updateShopLogo(data)
            toast.info("Update Image OK")
            this.setState({updatePhotos: false})

        }catch(err){
            toast.error("FAILED"+ err.message)
        } 

    }

    render() {
        console.log("STATE shop" ,this.state.shop)
        console.log("PROPS shop" ,this.props.shop)

        const { preview,updatePhotos} = this.state;
        return (
            <div>
                {preview &&
                    <PopUp
                        title="Aperçu"
                        // submit={
                        //     <button className="confirm btn btn-lg btn-primary" tabIndex="1" 
                        //         style={{ display: "inline-block" }} 
                        //         onClick={ this.props.update ? this.handleSubmitUpdate : this.handleSubmit }
                        //     >
                        //         Ajouter
                        //     </button>
                        // }
                        close={() => this.setState({ preview: false }) }
                        submitAction={ this.props.update ? this.handleSubmitUpdate : this.handleSubmit }
                        submitTitle="Valider" 
                        // disabledSubmit={this.props.STATE.sales.fetching || this.state.sending}
                    >
                        <PreviewFacture
                            // SHOPS
                            // getPhoto={this.props.getPhoto}
                            // update={this.props.update}
                            {...this.props}
                            shop={this.state.shop}
                        />
                    </PopUp>
                }

                <Box p={2}>
                    <small>* Champs obligatoires</small>

                    {/* DISABLE SHOP */}
                    <Box p={1}>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.shop.shop_disabled}
                                    onChange={(e) => this.setState({
                                        ...this.state,
                                        shop : {
                                            ...this.state.shop,
                                            shop_disabled: e.target.checked
                                        } 
                                    })}
                                    name="shop_disabled"
                                    color="primary"
                                    labelPlacement="right"
                                />
                            }
                            label="Magasin Désactivé"
                        />
                    </Box>


                    <InputText type="text" id="name" change={this.handleChange} value={this.state.shop.name} error={this.state.errors.name} name="name" placeholder="Nom du magasin"/>
                            
                    <InputText type="text" id="address" change={this.handleChange} value={this.state.shop.address} error={this.state.errors.address} name="address" placeholder="Adresse du magasin"/>
                
                    <InputText type="text" id="city" change={this.handleChange} value={this.state.shop.city} error={this.state.errors.city} name="city" placeholder="Ville du magasin"/>
                
                    <InputText type="text" id="country" change={this.handleChange} value={this.state.shop.country} error={this.state.errors.country} name="country" placeholder="Pays"/>
                
                    <InputText type="text" id="tel" change={this.handleChange} value={this.state.shop.tel} error={this.state.errors.tel} name="tel" placeholder="Téléphone"/>
                
                    <InputText type="text" id="tel2" change={this.handleChange} value={this.state.shop.tel2} error={this.state.errors.tel2} name="tel2" placeholder="Téléphone 2"/>
                
                    <InputText type="text" id="email" change={this.handleChange} value={this.state.shop.email} error={this.state.errors.email} name="email" placeholder="Email"/>
           
                    <TextArea id="bottom_info" change={this.handleChange} value={this.state.shop.bottom_info} error={this.state.errors.bottom_info} name="bottom_info" placeholder="Infos Pied de page Facture"
                    rows={5}/>
                    <TextArea id="bottom_info2" change={this.handleChange} value={this.state.shop.bottom_info2} error={this.state.errors.bottom_info2} name="bottom_info2" placeholder="Infos Pied de page Facture" rows={3} />

                    <TextArea id="bottom_info3" change={this.handleChange} value={this.state.shop.bottom_info3} error={this.state.errors.bottom_info3} name="bottom_info3" placeholder="Infos Pied de page Facture" rows={3} />

                    <InputText type="text" id="latitude" change={this.handleChange} value={this.state.shop.latitude} error={this.state.errors.latitude} name="latitude" placeholder="Latitude"/>

                    <InputText type="text" id="longitude" change={this.handleChange} value={this.state.shop.longitude} error={this.state.errors.longitude} name="longitude" placeholder="Longitude"/>
                   
                    {!this.props.update &&
                        <div className={"form-group "}>
                            <label className="col-sm-2 control-label">Logo</label>
                            <Photos photoList={this.setPhotos} photos={this.state.shop.photo === null ? [] : this.state.shop.photo } max={1}/>
                        </div>
                    }

                    <Box p={1}>
                        <Button 
                            className="confirm btn btn-lg btn-primary" 
                            type="button"
                            variant="contained"
                            color="primary"
                            // style={{ display: "inline-block" }} 
                            onClick={ this.validate }
                        >
                            Valider
                        </Button>
                    </Box>
                    {this.props.update &&
                        <Box p={1} style={{textAlign: "right"}}>
                        <Button color="primary" variant="contained" onClick={() => this.setState({updatePhotos: true})}>Modifier Photos</Button>
                        </Box>
                    }
                    {updatePhotos &&
                        <PopUp
                            close={()=> this.setState({ updatePhotos: false })}
                            submitAction={this.handleSubmitPhotos}
                            maxWidth="sm"
                            title="Modifier photos"
                            disabledSubmit={this.props.STATE.products.fetching}
                        >
                            <Box p={1}>
                                <Photos photoList={(photos) => this.setState({ photos})} photos={this.state.photos === null ? [] : this.state.photos } />
                            </Box>
                        </PopUp>
                    }
                                  
                </Box>
            </div>
    
        );
    }
}

export default FormShop;